export const DEFAULT_PHONE = '(800) 375-3403';
export const PRO_PHONE = '(800) 471-4956';
export const FERG_HOME_PHONE = '(800) 638-8875';

export const HOME_CATEGORY_PHONE_NUMBERS = {
	appliances: '(855) 484-3292',
	flooring: '(855) 484-3293'
};
